import * as app from './app/types';
import * as appBar from './app-bar/types';

export type TReducerRootState = {
    app: app.TReducerState;
    appBar: appBar.TReducerState;
};

export type TReduxActionBasicGeneric<
    T,
    B extends app.EActionTypes | appBar.EActionTypes,
> = (args0: T) => {
    type: B;
    payload: Parameters<TReduxActionBasicGeneric<T, B>>[0];
};

export enum EActionTypes {
    RESET = 'GLOBAL_RESET',
}
